module.exports = __webpack_public_path__ + "static/media/no-image.bc37f4df.png";